var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "contactInfoModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable",
        },
        [
          _c("ValidationObserver", {
            ref: "contactModal",
            staticClass: "modal-content",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("聯繫資訊"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [
                        _c(
                          "el-table",
                          {
                            key: _vm.tableKey,
                            staticClass: "mb-3",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.contactHistory, stripe: "" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "expand" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(props.row.Remark) + " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "職缺",
                                prop: "ManpowerDemandName",
                                "min-width": "100",
                                "show-overflow-tooltip": true,
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { label: "聯繫時間" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$common.dateTimeFormatter(
                                                scope.row.ContactTime
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "邀約狀態" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.ContactStatus.Name
                                            ) +
                                            "-" +
                                            _vm._s(
                                              scope.row.ContactStatusSecond.Name
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "聯繫人資" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.CreateUserName) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top",
                                              width: "150px",
                                            },
                                            model: {
                                              value:
                                                _vm.delPopover[scope.$index],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.delPopover,
                                                  scope.$index,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "delPopover[scope.$index]",
                                            },
                                          },
                                          [
                                            _c("p", [_vm._v("確認刪除？")]),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                  margin: "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.cancel(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 取消 ")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.delRecord(
                                                          scope.row.Id,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 確定 ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [_vm._v("删除")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group form-inline" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("職缺"),
                            ]),
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  "value-key": "ManpowerDemandNo",
                                  placeholder: "請選擇",
                                },
                                model: {
                                  value: _vm.contact.ManpowerDemandNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "ManpowerDemandNo",
                                      $$v
                                    )
                                  },
                                  expression: "contact.ManpowerDemandNo",
                                },
                              },
                              _vm._l(_vm.openingOptions, function (opening) {
                                return _c("el-option", {
                                  key: opening.ManpowerDemandNo,
                                  attrs: {
                                    label: opening.ManpowerDemandName,
                                    value: opening.ManpowerDemandNo,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group form-inline" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _c("span", { staticClass: "mark" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("聯繫時間"),
                            ]),
                            _c("ValidationProvider", {
                              staticClass: "w-100",
                              attrs: { rules: "required", name: "聯繫時間" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("el-date-picker", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "datetime",
                                            format: "yyyy-MM-dd HH:mm",
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            "picker-options": {
                                              disabledDate:
                                                _vm.$common
                                                  .disabledTimeAfterNowTime,
                                            },
                                            "default-time": "08:00:00",
                                            placeholder: "請選擇日期時間",
                                          },
                                          model: {
                                            value: _vm.contact.ContactTime,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.contact,
                                                "ContactTime",
                                                $$v
                                              )
                                            },
                                            expression: "contact.ContactTime",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger",
                                            staticStyle: {
                                              "font-size": "13px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group form-inline" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _c("span", { staticClass: "mark" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("聯繫狀態"),
                            ]),
                            _c("ValidationProvider", {
                              staticClass: "w-100",
                              attrs: { rules: "required", name: "聯繫狀態" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("el-cascader", {
                                          staticClass: "w-100",
                                          attrs: {
                                            options: _vm.contactOptions,
                                            clearable: "",
                                            "show-all-levels": true,
                                            placeholder: "請選擇",
                                          },
                                          model: {
                                            value:
                                              _vm.contact.ContactStatusForFront,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.contact,
                                                "ContactStatusForFront",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "contact.ContactStatusForFront",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger",
                                            staticStyle: {
                                              "font-size": "13px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group form-inline" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("備註"),
                            ]),
                            _c("el-input", {
                              staticClass: "w-100",
                              attrs: {
                                type: "textarea",
                                rows: 4,
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.contact.Remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.contact, "Remark", $$v)
                                },
                                expression: "contact.Remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v(" 關閉 ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return handleSubmit(_vm.saveRecord)
                            },
                          },
                        },
                        [_vm._v(" 儲存 ")]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }